<template>
    <div class="tool-container fx-v-center">
        <i class="iconfont iconfont-back icongonggongfanhui" @click="goTo(list[0].url, 0)"/>
        <span v-for="(item, index) in list" :class="{'now': index == list.length - 1}" :key="index" @click="goTo(item.url, index)">{{item.text}}<span v-if="index != list.length - 1">&nbsp;/&nbsp;</span></span>
    </div>
</template>

<script>
export default {
    methods: {
        goTo(url, i) {
            if (i === this.list.length - 1) {
                return
            }
            this.$router.replace(url)
        }
    },
    props: {
        list: {
            type: Array,
            /**
             * @param val 必须是这种格式，除了最后一个 [ { url: 'xxx', text: 'xxx' }, { text: 'xxx' } ]
             */
            validator(val) {
                const len = val.length
                return val.every((el, i) => {
                    if (Object.prototype.toString.call(el) !== '[object Object]') {
                        return false
                    }
                    if (i !== len - 1) {
                        return typeof el.url === 'string'
                    }
                    return true
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.tool-container {
    height: 50px;
    font-size: 14px;
    color: #999;
    letter-spacing: 0;
    ;

    .iconfont-back {
        width: 20px;
        height: 20px;
        margin-right: 4px;

        &::before {
            color: #999;
            font-size: 20px;
            cursor: pointer;
        }
    }

    > span:not(:last-child) {
        cursor: pointer;
    }

    > * {
        display: inline-block;
        vertical-align: middle;
    }

    .now {
        color: #151515;
    }
}
</style>